import React, { useEffect, useState } from "react";
import { Job } from "../../../docuclipper/DocuclipperTypes";
import ClipLoader from "react-spinners/ClipLoader";
import { Badge, ProgressBar, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ReduxState } from "../../../redux";
import moment from "moment";
import JobInProgressInfoCards from "../../Docuclipper/JobInProgressInfoCards/JobInProgressInfoCards";

const SECONDS_PER_PAGE = 1; // Initial estimate of 1 second per page

export const JobInProgress = ({ job }: { job: Job }) => {
  const [timeRemaining, setTimeRemaining] = useState<string | null>(null);

  let text = "";
  if (job.type === "ExtractData") {
    text = "Converting documents";
  } else if (job.type === "WritePdf") {
    text = "Populating documents";
  } else if (job.type === "EditDocument") {
    text = "Editing documents";
  }

  const { progress } = useSelector((state: ReduxState) => state.JobData);
  const progress2 = ((progress || 0) * 100).toFixed(0);

  useEffect(() => {
    // If we have progress, calculate based on elapsed time and progress
    if (progress !== null && progress > 0) {
      const startTime = moment(job.createdAt);
      const elapsedTime = moment().diff(startTime);
      const estimatedTotalTime = elapsedTime / progress;
      const remainingTime = estimatedTotalTime - elapsedTime;

      if (remainingTime > 0) {
        const duration = moment.duration(remainingTime);
        if (duration.asMinutes() < 1) {
          setTimeRemaining("Less than a minute remaining");
        } else if (duration.asHours() < 1) {
          setTimeRemaining(
            `${Math.round(duration.asMinutes())} minutes remaining`,
          );
        } else {
          setTimeRemaining(`${Math.round(duration.asHours())} hours remaining`);
        }
      } else {
        setTimeRemaining("Finishing up...");
      }
    } else {
      // If no progress yet, estimate based on total pages
      const estimatedTotalSeconds = (job.totalJobs || 0) * SECONDS_PER_PAGE;
      const duration = moment.duration(estimatedTotalSeconds * 1000);

      if (duration.asMinutes() < 1) {
        setTimeRemaining("Less than a minute remaining");
      } else if (duration.asHours() < 1) {
        setTimeRemaining(
          `${Math.round(duration.asMinutes())} minutes remaining`,
        );
      } else {
        setTimeRemaining(`${Math.round(duration.asHours())} hours remaining`);
      }
    }
  }, [progress, job.createdAt, job.totalJobs]);

  // console.log({ job });
  return (
    <div>
      <Row className="align-items-center">
        <div className="h3">{text}</div>
        <div className="ml-2 d-flex align-items-center">
          <ClipLoader />
          <span className="ml-2 text-muted" style={{ fontSize: "1.1rem" }}>
            {timeRemaining}
          </span>
        </div>
      </Row>
      <Row>
        {progress === null && (
          <Badge
            variant="primary"
            style={{ width: "15vw", fontSize: "1.2rem" }}
          >
            In Progress
          </Badge>
        )}
        {progress !== null && (
          <ProgressBar
            variant="primary"
            animated={true}
            style={{ width: "15vw", fontSize: "1.2rem", height: "30px" }}
            now={parseFloat(progress2)}
            label={`${progress2}%`}
          />
        )}
      </Row>
      {job.type === "ExtractData" && (
        <Row className="mt-4">
          <div className="text-muted small">
            Once done, export your data to{" "}
            <strong>Excel</strong>,{" "}
            <strong>QuickBooks</strong>,{" "}
            <strong>Xero</strong>, or{" "}
            <strong>CSV</strong>. All formats are available from the results page.
          </div>
        </Row>
      )}
      <Row>
        <JobInProgressInfoCards job={job} />
      </Row>
    </div>
  );
};
